import { render, staticRenderFns } from "./NewLoanOffer.vue?vue&type=template&id=167a85fc"
import script from "./NewLoanOffer.vue?vue&type=script&lang=js"
export * from "./NewLoanOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports